import React from 'react'

export const ClinicEdit = () => {
    return (
        <form className='bg-white rounded-lg h-full my-10 px-16 pt-16 flex flex-col w-full shadow-lg'>
            <h2 className='font-bold text-xl'>C4C Name</h2>
            <div className='mt-10 w-full grid grid-cols-2 gap-3 justify-center items-center'>
                <div className='col-span-2'>
                    <label htmlFor='name' className=''>Clinic Name</label>
                    <input type='text' id='name' className='border border-blue-500 rounded-lg p-2 w-full' />
                </div>
                <div className='col-span-2'>
                    <label htmlFor='name' className=''>Clinic GSTIN:</label>
                    <input type='text' id='name' className='border border-blue-500 rounded-lg p-2 w-full' />
                </div>
                <div className=''>
                    <label htmlFor='name' className=''>Clinic City:</label>
                    <input type='text' id='name' className='border border-blue-500 rounded-lg p-2 w-full' />
                </div>
                <div className=''>
                    <label htmlFor='name' className=''>State:</label>
                    <input type='text' id='name' className='border border-blue-500 rounded-lg p-2 w-full' />
                </div>
                <div className=''>
                    <label htmlFor='name' className=''>Clinic Email:</label>
                    <input type='email' id='name' className='border border-blue-500 rounded-lg p-2 w-full' />
                </div>
                <div className=''>
                    <label htmlFor='name' className=''>Clinic Contact Number:</label>
                    <input type='text' id='name' className='border border-blue-500 rounded-lg p-2 w-full' />
                </div>
            </div>
            <div className='mt-16 flex justify-center items-center'>
                <button className='bg-blue-500 w-fit text-white py-2 px-5 rounded-lg '>Submit</button>
            </div>
        </form>
    )
}
